(() => {
  angular
    .module('gm.common.filters')
    .filter('gmCurrencySign', gmCurrencySignFilter);

  function gmCurrencySignFilter(
    GmyCurrencies
  ) {
    'ngInject';

    const currencies = GmyCurrencies.getCurrencyHash();

    return (currencyCode, showGauIfGold = false) => {
      const currency = currencies[currencyCode];

      if (currency) {
        return (showGauIfGold && (currencyCode === 'GAU')) ? 'GAU' : currency.sign;
      }
      return '';
    };
  }
})();
